import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/reports/sales-statistics')({
  component: SalesSummaryReportLayout,
  loader: ({ context }) => {
    if (!context.ability.can('list', 'transactions')) throw notFound()
  },
})

function SalesSummaryReportLayout() {
  return <Outlet />
}
